import * as React from "react";
import {connect} from "react-redux";
import "./styles.scss";
import * as request from "request";
import {shareLinkToAndroid} from "utils/android";
import {applyUrl, androidAppPackage, dynamicLinkUrlPrefix, firebaseApiKey, imageBaseUrl} from "config";
import {RouteComponentProps} from "react-router-dom";
import {useEffect, useState} from "react";

interface IConnectProps {
    userId: number;
    dispatch?: (action: any) => void;
    loading: boolean;
    isAndroid: boolean;
}

function generateReferralLink(updateReferralLink, userId) {
    const longDynamicLink = `${dynamicLinkUrlPrefix}?link=${applyUrl}?utm_campaign%3Dreferral%26utm_medium%3D${userId}%26utm_source%3DSCUR&apn=${androidAppPackage}&afl=https://play.google.com/store/apps/details?id%3D${androidAppPackage}%26referrer%3Dutm_source%253DSCUR%2526utm_medium%253D${userId}%2526utm_campaign%253Dreferral`;
    request(
        {
            method: "POST",
            url: `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${firebaseApiKey}`,
            header: {
                "content-type": "application/json",
            },
            body: {
                longDynamicLink,
            },
            rejectUnauthorized: false,
            json: true,
        },
        (err, res, body) => {
            updateReferralLink(body.shortLink);
        },
    );
}
function ReferralLink(props: IConnectProps & RouteComponentProps) {
    const [isReferralLinkCopied, updateReferralLinkCopied] = useState<boolean>(false);
    const [referralLink, updateReferralLink] = useState<string>("");
    function copyReferralLink() {
        if (props.isAndroid) {
            return shareLinkToAndroid(referralLink);
        } else {
            // updateEvents({}, "Refer & Earn - Share Link", EVENT_TYPE.EVENT);
        }
        const textField = document.createElement("textarea");
        textField.innerText = referralLink;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand("copy");
        textField.remove();
        updateReferralLinkCopied(true);
    }
    useEffect(() => {
      generateReferralLink(updateReferralLink, props.userId);
    }, []);
    return (
        <div className="col-md-6 offset-md-3 layout-remove-padding">
            <div className="text-center">
                <div className="card">
                    <div className="mb-3 p-1">
                        <LogoAndHeading/>
                        <CopyLink
                            isAndroid={props.isAndroid}
                            referralLink={referralLink}
                            isReferralLinkCopied={isReferralLinkCopied}
                            copyReferralLink={copyReferralLink}
                        />
                        <Offer/>
                        <TermsAndConditions/>
                    </div>
                </div>
            </div>
        </div>
    );
}
function TermsAndConditions() {
    return (
        <div className="px-3">
            <p><u><span className="referral_link">Terms &amp; Conditions</span></u></p>
            <div className="text-left">
                <p className="TC-text">
                    1. Paytm cashback amount will be calculated and credited for each successful
                    referral. A referral is considered successful when the application has been
                    approved and the loan amount has been disbursed from MyShubhLife.
                </p>
                <p className="TC-text">
                    2. The referral must download and apply via the referral link only.
                    Without the referral link authentication, MyShubhLife is NOT liable
                    to give Paytm cashback.
                </p>
                <p className="TC-text">
                    3. The referral Paytm cashback amount will be credited within 30 days
                    of successful disbursement.
                </p>
                <p className="TC-text">
                    4. If you are a sales intermediary/partner, your referral commission
                    will be as per your agreement with your area sales manager.
                </p>
            </div>
        </div>
    );
}
function CopyLink(props: any) {
    return (
        <div>
            <div className="text-copied"
                 style={{display: `${props.isReferralLinkCopied ? "block" : "none"}`}}
            >
                Refer Link Copied!
            </div>
            <div className="mt-4 mb-4 mx-auto" style={{maxWidth: "75%"}}>
                <div className="form-control rounded-0  text-center list-g">
                    {props.referralLink}
                </div>
                <button
                    className="btn btn-block btn-refer rounded-0"
                    onClick={props.copyReferralLink}
                > {props.isAndroid ? "Share link" : "Copy link"}
                </button>
            </div>
        </div>
    );
}
function LogoAndHeading() {
    return (
        <div>
            <img className="gift" src={`${imageBaseUrl}/img/paytm_cashback.png`}
                 alt="Refer"/>
            <h5>
                <small className="text-secondary">Refer MyShubhLife to your family and friends</small>
            </h5>
        </div>
    );
}
function Offer() {
    return (
        <p className="text-secondary">
            <strong>
                Earn upto INR 500 <span style={{color: "#042e6f"}}>Pay</span>
                <span style={{color: "#00baf2"}}>tm</span> Cashback for each successful
                disbursal coming from your referral
            </strong>
        </p>
    );
}

const mapStateToProps = (state): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    return {
        userId: auth.userId,
        loading: state.consent.loading,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ReferralLink);
